class InactivePlaceError extends Error {
    place;
    constructor(place) {
        super(`${place.type} ${place.legacyId} is not active`);
        this.place = place;
    }
}
export default InactivePlaceError;
